export const ABOUT_BUSINESS_PAGE_KEY = 'BD';
export const TAX_FINANCE_PAGE_KEY = 'TF';
export const BUSINESS_FINANCE_PAGE_KEY = 'BF';
export const BUSINESS_DETAILS_PAGE_KEY = 'CD';
export const GDPR_PAGE_KEY = 'GD';
export const REVIEW_PAGE_KEY = 'RV';
